<!--Copy right - © 2024 tecera gmbh-->
<script>
    import { Link } from "svelte-routing";
    import EinstellungenButton from "./buttons/EinstellungenButton.svelte";
    import { user_permissions, logout, user_role } from "../scripts/auth.js";
    import { fade } from "svelte/transition";
    import { onMount } from "svelte";
    export let headline;

    let is_mounted = false;
    onMount(() => {
        is_mounted = true;
    });

    function is_active(url) {
        return url === window.location.pathname;
    }

    function handle_logout() {
        let message = "Erfolgreich abgemeldet";
        logout({ info_message: message });
    }

    let pages = [
        {
            id: 1,
            name: "Hydranten",
            url: "/hydranten",
            disabled: $user_permissions["access_hymo"] == 1 ? false : true,
        },
        {
            id: 2,
            name: "Wasserzähler",
            url: "/wasserzaehler",
            disabled:
                $user_permissions["access_water_meter"] == 1 ? false : true,
        },
        {
            id: 3,
            name: "trinkwasser-Netzdaten",
            url: "/trinkwasser",
            disabled:
                $user_permissions["access_drinking_water"] == 1 ? false : true,
        },
    ];

    let settings = [];
    $user_role["view_assembly"] == 1
        ? settings.push({
              id: 1,
              name: "Montage-Übersicht",
              url: "/montage_uebersicht",
          })
        : null;
    $user_role["view_user_management"] == 1
        ? settings.push({
              id: 2,
              name: "Nutzer",
              url: "/user_management",
          })
        : null;
    $user_role["rank"] <= 2
        ? settings.push({
              id: 3,
              name: "Geräte",
              url: "/device_management",
          })
        : null;
</script>

<nav class="navbar navbar-expand-lg navbar-light pt-3 pb-3 mb-2 border-bottom">
    <!-- Logo-->
    <div>
        <div class="navbar-brand">
            <img
                class="logo"
                src="img/ewe-Logo.svg"
                alt="Ewe - Logo"
                style="max-width:20vw;"
            />
        </div>
    </div>

    <!-- Headline -->
    {#if is_mounted}
        <p
            id="next_headline"
            style="min-width: 40%;flex: 0 0 40%;"
            transition:fade|local
        >
            NEXT - {headline}
        </p>
    {/if}

    <!-- Navbar Button for small screens -->
    <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNavDropdown"
        aria-controls="navbarNavDropdown"
        aria-expanded="false"
        aria-label="Toggle navigation"
    >
        <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Navbar pages -->
    <div class="collapse navbar-collapse" id="navbarNavDropdown">
        <ul class="navbar-nav mt-4 mt-lg-0">
            {#each pages as item (item.id)}
                <li class="nav-item {is_active(item.url) ? 'active' : ''}">
                    {#if item.disabled}
                        <a class="nav-link disabled" href={item.url}
                            >{item.name}</a
                        >
                    {:else}
                        <Link class="nav-link" to={item.url}>{item.name}</Link>
                    {/if}
                </li>
            {/each}

            <!-- Einstellungen Dropdown -->
            {#if settings.length > 0}
                <EinstellungenButton {settings} />
            {/if}

            <!-- Abmelden Button -->
            <li class="nav-item" style="flex-grow:0;">
                <Link
                    class="nav-link navbar-text-custom"
                    on:click={handle_logout}>Abmelden</Link
                >
                <Link class="nav-link navbar-icon" on:click={handle_logout}
                    ><i
                        class="fa-solid fa-right-from-bracket"
                        style="font-size: 18px;"
                    ></i></Link
                >
            </li>
        </ul>
    </div>
</nav>
